export const LabelEnterprise = () => {
  return (
    <label className="nj-label-free nj-label-enterprise" data-e2e="label-tier-enterprise">Enterprise</label>
  );
};
